// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__JC6E4","plus":"styles_plus__g256p","key":"styles_key__zopkt"};